import { defineMessages } from 'react-intl';

/**
 * The description of a cast picture (fix 2026-10-18): what the AI reads in the picture, which the
 * director uses word for word, and the prompts for the people of a story with no picture.
 */
export const castDescriptionMessages = defineMessages({
  reading: { id: 'app.sml.musicVideo.directed.cast.description.reading', defaultMessage: 'Reading the picture…' },
  title: { id: 'app.sml.musicVideo.directed.cast.description.title', defaultMessage: 'What the director sees' },
  byYou: { id: 'app.sml.musicVideo.directed.cast.description.byYou', defaultMessage: 'Your words' },
  failed: {
    id: 'app.sml.musicVideo.directed.cast.description.failed',
    defaultMessage: 'We could not read this picture. Write what it shows: the director uses your words.',
  },
  none: {
    id: 'app.sml.musicVideo.directed.cast.description.none',
    defaultMessage: 'Write what this picture shows. The director uses your words.',
  },
  edit: { id: 'app.sml.musicVideo.directed.cast.description.edit', defaultMessage: 'Correct it' },
  describe: { id: 'app.sml.musicVideo.directed.cast.description.describe', defaultMessage: 'Describe it' },
  artStyle: { id: 'app.sml.musicVideo.directed.cast.description.artStyle', defaultMessage: 'Art style' },
  artStyleHint: {
    id: 'app.sml.musicVideo.directed.cast.description.artStyleHint',
    defaultMessage: 'Photo, neon line-art illustration, 3D render…',
  },
  subject: { id: 'app.sml.musicVideo.directed.cast.description.subject', defaultMessage: 'Who or what' },
  appearance: { id: 'app.sml.musicVideo.directed.cast.description.appearance', defaultMessage: 'Look' },
  appearanceHint: {
    id: 'app.sml.musicVideo.directed.cast.description.appearanceHint',
    defaultMessage: 'Hair, face, clothes, colours, marks',
  },
  keep: { id: 'app.sml.musicVideo.directed.cast.description.keep', defaultMessage: 'Keep the same (with commas)' },
  keepLine: { id: 'app.sml.musicVideo.directed.cast.description.keepLine', defaultMessage: 'Keep: {items}' },
  save: { id: 'app.sml.musicVideo.directed.cast.description.save', defaultMessage: 'Save' },
  cancel: { id: 'app.sml.musicVideo.directed.cast.description.cancel', defaultMessage: 'Cancel' },

  // The people, places and objects of the chosen story that have no picture (owner request 2026-10-20)
  charactersTitle: {
    id: 'app.sml.musicVideo.directed.cast.subjects.title',
    defaultMessage:
      '{count, plural, one {This story has a person, place or thing with no picture.} other {This story has # people, places or things with no picture.}}',
  },
  charactersText: {
    id: 'app.sml.musicVideo.directed.cast.subjects.text',
    defaultMessage:
      'With no picture, the AI makes it look different in every shot. Add a picture or make one, so it looks the same in the whole video.',
  },
  characterMake: {
    id: 'app.sml.musicVideo.directed.cast.characters.make',
    defaultMessage: 'Make a picture of {name}',
  },
  // The button of the banner uses the one forward label of the cast step (`castMessages.goOn`).
  charactersDone: {
    id: 'app.sml.musicVideo.directed.cast.subjects.ready',
    defaultMessage: 'Every person, place and thing of the story has a picture.',
  },

  storyNeedsPictures: {
    id: 'app.sml.musicVideo.directed.story.needsPictures',
    defaultMessage: 'Needs a cast picture: {names}',
  },

  // The style step
  fitConflict: {
    id: 'app.sml.musicVideo.directed.style.fit.conflict',
    defaultMessage:
      'This style does not match the art style of your cast pictures. The video can look broken. Pick a style in the same art style, or say "mixed media" in the texture.',
  },
  fitMixed: {
    id: 'app.sml.musicVideo.directed.style.fit.mixed',
    defaultMessage: 'This style mixes art styles. Check that this is what you want.',
  },
  fitReason: { id: 'app.sml.musicVideo.directed.style.fit.reason', defaultMessage: 'The director: {reason}' },
});
